const d3 = require('d3')
const moment = require('moment');
const { parseDate } = require('../utils/formatters.js');
const { wrap } = require( '../utils/shared-functions.js');
const { glucoseConvert } = require('../utils/converter.js');

const HIGH_GLUCOSE_LEVEL_COLOR = '#B7351B';
const MEDIUM_GLUCOSE_LEVEL_COLOR = '#D4B806';
const NORMAL_GLUCOSE_LEVEL_COLOR = '#347702';
const LOW_GLUCOSE_LEVEL_COLOR = '#B7351B';

const HIGH_GLUCOSE_LEVEL_BG_COLOR = '#F4B297';
const MEDIUM_GLUCOSE_LEVEL_BG_COLOR = '#FFE992';
const NORMAL_GLUCOSE_LEVEL_BG_COLOR = '#D3E0AA';
const LOW_GLUCOSE_LEVEL_BG_COLOR = '#F4B297';

const DEVICE_COLOR = '#6DA758';
const EXTERNALL_COLOR = '#CF42F0';
const MANUAL_COLOR = '#558AC2';
const EMPTY_COLOR = '#000000';


exports.createGlucoseChart = function (rawData, manualData,thresholds,onClick,width,height,glucose_unit,thresholdsStatus) {

  const margin = { top: 40, right: 30, bottom: 40, left: 50 };
  const MAX_GLUCOSE = {'mg/dL': 420, 'mmol/L': glucoseConvert(420, 'mmol/L')}
  const MIN_GLUCOSE = {'mg/dL': 20,'mmol/L': glucoseConvert(20, 'mmol/L')}
  const { glucose: glucose_threshold } = thresholds;
  glucose_threshold.low = glucoseConvert(glucose_threshold.low, glucose_unit);
  glucose_threshold.high = glucoseConvert(glucose_threshold.high, glucose_unit);
  const TICK_VALUES = [20, 70, 120, 170, 220, 270, 320, 370, 420].map((val) => glucoseConvert(val, glucose_unit));

  const emptyMap = {};
  let data = [];
  const data_device = rawData.map((d) => {
    const momentFormatted = moment(d['date']).format('YYYY-MM-DD');
    const date = parseDate(momentFormatted);
    emptyMap[momentFormatted] = d['value'] ? d['value'] : emptyMap[momentFormatted];
    const obj = {
      date,
      data: glucoseConvert(d['value'], glucose_unit),
      color: EXTERNALL_COLOR
    };
    return obj;
  });

    const data_manual = manualData.map((d) => {
      const momentFormatted = moment(d['date']).format('YYYY-MM-DD');
      const date = parseDate(momentFormatted);
      emptyMap[momentFormatted] = d['value'] ? d['value'] : emptyMap[momentFormatted];
      const obj = {
        date,
        data: glucoseConvert(d['value'], glucose_unit),
        color: MANUAL_COLOR,
      };
      return obj;
    });

  data = data.concat(data_device).concat(data_manual);
  const x = d3
    .scaleBand()
    .domain(d3.utcDay.range(data[0].date, +data[data.length - 1].date + 1))
    .range([margin.left, width - margin.right])
    .padding(0.4);

  const y = d3
    .scaleLinear()
    .domain([MIN_GLUCOSE[glucose_unit], MAX_GLUCOSE[glucose_unit]])
    .nice()
    .range([height - margin.bottom, margin.top]);

  const xAxis = (g) =>
    g
      .attr('transform', `translate(0,${height - margin.bottom - 2})`)
      .call(
        d3
          .axisBottom(x)
          .tickValues(d3.utcDay.every(1).range(data[0].date, +data[data.length - 1].date + 1))
          .tickFormat((d) => moment(d).format('ddd DD'))
          .tickSize(0)
      )
      .call((g) =>
      g.selectAll('.tick line')
        .clone()
        .attr('stroke-opacity', 0.2)
        .attr('transform', `translate(0,${-height + margin.top + margin.bottom + 3})`)
        .attr('y2', height - margin.top - margin.bottom)
    )
      .call((g) => g.select('.domain').remove());

  const yAxis = (g) =>
    g
      .attr('transform', `translate(${margin.left - 10},0)`)
      .call(
        d3
          .axisLeft(y)
          .tickValues(TICK_VALUES)
          .tickSize(0)
          .tickPadding(10)
      )
      .call((g) =>
        g
          .selectAll('.tick line')
          .clone()
          .attr('stroke-opacity', 0.2)
          .attr('x2', width - margin.left - margin.right)
      )
      .call((g) => g.select('.domain').remove());

  const svg = d3
    .create('svg')
    .attr('width', width)
    .attr('height', height);

    if(thresholdsStatus=== 'on'){
      const lowGlucoseBackgroundColor = svg
    .append('rect')
    .attr('x', x(data[0].date))
    .attr('y', y(glucose_threshold.low || TICK_VALUES[1]))
    .attr('width', Math.abs(x(data[data.length - 1].date) - x(data[0].date)) + x.bandwidth())
    .attr('height', Math.abs(y(glucose_threshold.low || TICK_VALUES[1]) - y(MIN_GLUCOSE[glucose_unit])))
    .attr('fill', LOW_GLUCOSE_LEVEL_BG_COLOR)
    .attr('opacity', 0.4);

  const normalGlucoseBackgroundColor = svg
    .append('rect')
    .attr('x', x(data[0].date))
    .attr('y', y(glucose_threshold.high || 120))
    .attr('width', Math.abs(x(data[data.length - 1].date) - x(data[0].date)) + x.bandwidth())
    .attr('height', Math.abs(y(glucose_threshold.high || TICK_VALUES[2]) - y(glucose_threshold.low || TICK_VALUES[1])))
    .attr('fill', NORMAL_GLUCOSE_LEVEL_BG_COLOR)
    .attr('opacity', 0.4);

  const mediumGlucoseBackgroundColor = svg
    .append('rect')
    .attr('x', x(data[0].date))
    .attr('y', y(TICK_VALUES[4]))
    .attr('width', Math.abs(x(data[data.length - 1].date) - x(data[0].date)) + x.bandwidth())
    .attr('height', Math.abs(y(TICK_VALUES[4]) - y(glucose_threshold.high || TICK_VALUES[2])))
    .attr('fill', HIGH_GLUCOSE_LEVEL_BG_COLOR)
    .attr('opacity', 0.4);

  const highGlucoseBackgroundColor = svg
    .append('rect')
    .attr('x', x(data[0].date))
    .attr('y', y(MAX_GLUCOSE[glucose_unit]))
    .attr('width', Math.abs(x(data[data.length - 1].date) - x(data[0].date)) + x.bandwidth())
    .attr('height', Math.abs(y(MAX_GLUCOSE[glucose_unit]) - y(TICK_VALUES[4])))
    .attr('fill', HIGH_GLUCOSE_LEVEL_BG_COLOR)
    .attr('opacity', 0.4);
    }

  svg.append('g').call(xAxis).selectAll('.tick text').call(wrap, x.bandwidth());

  svg.append('g').call(yAxis);

  const xAxisLabelDate = svg
    .append('text')
    .attr('x', 20)
    .attr('y', height - margin.bottom + 20)
    .style('font-size', '12px')
    .attr('font-weight', '100')
    .text('Date');

  const xAxisLabelDay = svg
    .append('text')
    .attr('x', 20)
    .attr('y', height - margin.bottom + 33)
    .style('font-size', '12px')
    .attr('font-weight', '100')
    .text('Day')
    .style("cursor", "pointer")
    .on("click", (e, d) => onClick(d.date));

  const yAxisLabelDate = svg
    .append('text')
    .attr('x', margin.left - 40)
    .attr('y', margin.top - 20)
    .style('font-size', '12px')
    .attr('font-weight', '100')
    .text(glucose_unit);

  const fixLabelXPosition = width / rawData.length / 3.7
  const g = svg
    .append('g')
    .selectAll('g')
    .data(data)
    .join('g')
    .attr('transform', (d) => `translate(${x(d.date) + fixLabelXPosition},0)`);

  const emptyGroup = g.append('g').attr('visibility', (d) => {
    const momentFormatted = moment(d['date']).format('YYYY-MM-DD');
    // using color condition in order to not render double empty bars
    return !emptyMap[momentFormatted] && d.color === MANUAL_COLOR ? 'visible' : 'hidden';
  });
  const emptyBar = emptyGroup
    .append('line')
    .attr('y1', (d) => y(TICK_VALUES[0]))
    .attr('y2', (d) => y(TICK_VALUES[TICK_VALUES.length - 1]))
    .attr('stroke-width', 36)
    .attr('stroke', EMPTY_COLOR)
    .attr('opacity', 0.07);

  const glucosePointsGroup = g.append('g').attr('visibility', (d) => {
    return d.data ? 'visible' : 'hidden';
  });

  const glucosePoint = glucosePointsGroup
    .append('circle')
    .attr('r', 3)
    .attr('cy', (d) => {
      return y(d.data);
    })
    .attr('stroke-width', 1)
    .attr('fill', (d) => d.color)
    .attr('stroke', (d) => d.color)
    .style("cursor", "pointer")
    .on("click", (e, d) => onClick(d.date));

  const gLegend = svg.append('g').attr('transform', (d) => `translate(${width-400},0)`);

  const glucoseLegendRect = gLegend
    .append('circle')
    .attr('cx', 190)
    .attr('cy', 20)
    .attr('r', 6)
    .attr('fill', EXTERNALL_COLOR);
  const glucoseLegendAverageText = gLegend
    .append('text')
    .attr('x', 200)
    .attr('y', 25)
    .style('font-size', '17px')
    .attr('font-weight', '100')
    .text('External measurements');
  const glucoseManualLegendRect = gLegend
    .append('circle')
    .attr('cx', -15)
    .attr('cy', 20)
    .attr('r', 6)
    .attr('fill', MANUAL_COLOR);
  const glucoseManualLegendText = gLegend
    .append('text')
    .attr('x', 0)
    .attr('y', 25)
    .style('font-size', '17px')
    .attr('font-weight', '100')
    .text('Manual measurements');

  const missingValuesLegendRect = gLegend
    .append('rect')
    .attr('x', -200)
    .attr('y', 16)
    .attr('width', 10)
    .attr('height', 10)
    .attr('opacity', 0.11)
    .attr('fill', '#000000');

  const missingValuesLegendText = gLegend
    .append('text')
    .attr('x', -180)
    .attr('y', 25)
    .style('font-size', '17px')
    .attr('font-weight', '100')
    .text('No measurements');

  return svg.node();
};
